import { ChevronRightIcon } from "@setel/web-ui";
import { LocaleLink } from "~/lib/components/link";
import ChatWidget from "../../ui/ChatWidget";
import { useMemo } from "react";

export interface IMoreHelpCard {
  title: string;
  detail: string;
  iconSrc: string;
  needAuthorized: boolean;
  href?: string;
  type?: "chat";
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export const MoreHelpCard = (props: IMoreHelpCard) => {
  const { title, detail, iconSrc, type, href, onClick } = props;

  const innerChildren = useMemo(
    () => (
      <div className="flex flex-row gap-3 items-center">
        <img src={iconSrc} width={44} height={44} alt={title} />
        <div className="flex-1 flex flex-col gap-1">
          <div className="hover:text-brand font-secondary text-[15px] leading-[21px] font-normal text-gray-dark">
            {title}
          </div>
          <div className="font-secondary text-sm text-gray-light">{detail}</div>
        </div>
        <ChevronRightIcon className="w-4 h-4 " />
      </div>
    ),
    [detail, iconSrc, title]
  );

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (onClick) {
      onClick(e);
    }
  };

  // this is special case for chat
  // we need to render chat widget instead of link
  if (type === "chat") {
    return (
      <div className="cursor-pointer">
        <ChatWidget tags={[]}>
          <a onClick={handleClick}>{innerChildren}</a>
        </ChatWidget>
      </div>
    );
  }

  return (
    <LocaleLink to={href!} onClick={handleClick}>
      {innerChildren}
    </LocaleLink>
  );
};
